import React from 'react';

import twMerge from 'utilities/src/twMerge';

import Image from '../../../Image';

/**
 * Widget Talent Pìll Props
 */

export type WidgetTalentPillProps = {
  image: {
    url: string;
    alt: string;
  };
  name: string;
  role: string;
  className?: string;
};

/**
 * Widget Talent Pill Component
 */

export default function WidgetTalentPill({ image, name, role, className }: WidgetTalentPillProps) {
  return (
    <div
      className={twMerge(
        'bg-site-neutrals-0 flex w-fit items-center gap-3 rounded-[1.25rem] py-1 pl-2 pr-12',
        className,
      )}
    >
      <div className="h-10 w-10 rounded-full">
        <Image src={image.url} alt={image.alt} width={80} height={80} className="rounded-full" />
      </div>

      <div className="flex flex-col">
        <span className="site-paragraph-m text-site-neutrals-600 font-normal">{name}</span>
        <span className="site-paragraph-xs text-site-neutrals-600 font-normal">{role}</span>
      </div>
    </div>
  );
}
